import { createContext, Dispatch, FCWithChildren, SetStateAction, useContext, useState } from 'react';
import { PaginationState } from '@interfaces/models/negotiation/domain/BuyingOffer';
import { ListingsProduct } from '@interfaces/models/negotiation/domain/ListingsProducts';
import { ListingsItemToShip } from '@interfaces/models/negotiation/domain/ListingsItemsToShip';

interface ListingsContextProps {
  listingsProductsList: ListingsProduct[];
  setListingsProductsList: Dispatch<SetStateAction<ListingsProduct[]>>;
  listingsProductsPaginationMeta: PaginationState;
  setListingsProductsPaginationMeta: Dispatch<SetStateAction<PaginationState>>;
  listingsItemsToShipList: ListingsItemToShip[];
  setListingsItemsToShipList: Dispatch<SetStateAction<ListingsItemToShip[]>>;
}

const ListingsContext = createContext<ListingsContextProps>({} as ListingsContextProps);

const ListingsProvider: FCWithChildren = ({ children }) => {
  const [listingsProductsList, setListingsProductsList] = useState<ListingsProduct[]>([]);
  const [listingsProductsPaginationMeta, setListingsProductsPaginationMeta] = useState<PaginationState>(null);
  const [listingsItemsToShipList, setListingsItemsToShipList] = useState<ListingsItemToShip[]>();

  const value = {
    listingsProductsList,
    setListingsProductsList,
    listingsProductsPaginationMeta,
    setListingsProductsPaginationMeta,
    listingsItemsToShipList,
    setListingsItemsToShipList,
  };

  return <ListingsContext.Provider value={value}>{children}</ListingsContext.Provider>;
};

const useListings = () => useContext(ListingsContext);

export { ListingsProvider, useListings };
